import { Typography, Box, StepContent, Step } from '@packages/shared';
import { useDeviceType } from '@packages/shared/src/hooks/useDeviceType/useDeviceType';
import { Stepper } from '@mui/material';
import { useIntl } from 'react-intl';
import { descriptions, titles } from './messages';
import { Connector } from './Connector';
import { Icon } from './Icon';
import { StepLabel } from './StepLabel';
import { gapBetweenIconAndText, iconSize } from './config';
import { SampleOrderSteps } from '../../SampleOrderSteps/types';

export type SampleOrderStepperProps = {
  step: SampleOrderSteps;
};

export const SampleOrderStepper = ({ step }: SampleOrderStepperProps) => {
  const { formatMessage } = useIntl();
  const { isMobile } = useDeviceType();

  return (
    <Box pt={[1.5, 1.5, 6]} px={[2, 2, 3]} sx={{ backgroundColor: 'common.white' }}>
      <Stepper
        activeStep={step}
        orientation={isMobile ? 'horizontal' : 'vertical'}
        connector={<Connector />}
      >
        {[
          SampleOrderSteps.SelectSamples,
          SampleOrderSteps.PersonalDataForm,
          SampleOrderSteps.Review,
          ...(step === SampleOrderSteps.Finished ? [SampleOrderSteps.Finished] : []),
        ].map((stepItem) => (
          <Step key={stepItem}>
            <StepLabel
              StepIconComponent={(props) => (
                <Icon {...props} isFinished={stepItem === SampleOrderSteps.Finished} />
              )}
            >
              {!isMobile && stepItem !== SampleOrderSteps.Finished && (
                <Typography variant="body2">{formatMessage(titles[stepItem])}</Typography>
              )}
            </StepLabel>
            {!isMobile && stepItem !== SampleOrderSteps.Finished && (
              <StepContent
                sx={{
                  ml: `${iconSize / 2}rem`,
                  pl: `${iconSize / 2 + gapBetweenIconAndText}rem`,
                }}
              >
                <Typography variant="body3" sx={{ display: 'block', minHeight: '7rem' }}>
                  {formatMessage(descriptions[stepItem])}
                </Typography>
              </StepContent>
            )}
          </Step>
        ))}
      </Stepper>
      {isMobile && step !== SampleOrderSteps.Finished && (
        <Box textAlign="center" my={1.5}>
          <Typography variant="h4" component="div">
            {formatMessage(titles[step])}
          </Typography>
        </Box>
      )}
    </Box>
  );
};
